exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".max-w-800[data-v-435c8f83] {\n  max-width: 800px;\n}", ""]);

// exports
